import { createContext, useContext } from "react";
import type { PurchaseOrder } from "../types/purchase-order.types";

export interface PurchaseOrderOverviewContextType {
  purchaseOrder: PurchaseOrder | null;
  refetch: () => Promise<void>;
}

const PurchaseOrderOverviewContext =
  createContext<PurchaseOrderOverviewContextType | null>(null);

export function usePurchaseOrderOverview() {
  const context = useContext(PurchaseOrderOverviewContext);
  if (!context) {
    throw new Error(
      "usePurchaseOrderOverview must be used within PurchaseOrderOverviewContext.Provider",
    );
  }
  return context;
}

export default PurchaseOrderOverviewContext;
